import {is_nested_object} from '@bitstillery/common/lib/utils'

/**
 * Nest dot-separated copy keys into the tree i18next resolves against — the browser-side twin of the
 * i18n endpoint's `_translations_to_nested_i18n_dict`, and it resolves a name that is both a value and a
 * namespace the same way: shortest key first, so the value wins. `page.title` is a page's hero string
 * *and* the namespace of the legacy `page.title.login`; letting the namespace win makes i18next answer
 * `$t('page.title')` with the literal "returned an object instead of string", straight into the page.
 */
export function flat_keys_to_nested(flat: Record<string, string>): Record<string, unknown> {
    const root: Record<string, unknown> = {}
    for (const flat_key of Object.keys(flat).sort()) {
        const trimmed = flat_key.trim()
        if (!trimmed) {
            continue
        }
        const parts = trimmed.split('.')
        const leaf = parts.pop()
        let node: Record<string, unknown> | null = root
        for (const p of parts) {
            const next: unknown = node[p] ?? (node[p] = {})
            if (!is_nested_object(next)) {
                node = null
                break
            }
            node = next
        }
        if (node && leaf !== undefined) {
            node[leaf] = flat[flat_key]
        }
    }
    return root
}
